import { Link } from "react-router-dom";

interface EmptyStateProps {
  title?: string;
  desc?: string;
  actionLabel?: string;
  onAction?: () => void;
  to?: string;
}

export default function EmptyState({
  title = "暂无相关内容",
  desc = "没有找到符合当前条件的条目，试试调整筛选条件或返回首页浏览其他内容。",
  actionLabel,
  onAction,
  to,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 md:py-24 px-4 bg-background-50 border border-dashed border-background-300 rounded-lg">
      <span className="w-16 h-16 rounded-full bg-background-100 flex items-center justify-center text-foreground-400 mb-5">
        <i className="ri-inbox-archive-line text-3xl"></i>
      </span>
      <h3 className="font-heading font-bold text-lg text-foreground-900">{title}</h3>
      <p className="mt-2 text-sm text-foreground-500 max-w-md leading-relaxed">{desc}</p>
      <div className="mt-6 flex items-center gap-3">
        {actionLabel && onAction && (
          <button
            type="button"
            onClick={onAction}
            className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {actionLabel}
          </button>
        )}
        {to && (
          <Link
            to={to}
            className="px-5 py-2.5 rounded-md bg-background-100 text-foreground-800 text-sm font-medium hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            返回首页
          </Link>
        )}
      </div>
    </div>
  );
}